module.exports = __webpack_public_path__ + "static/two_headed_cerberus-d61e3e4de5b2cdfd912cdafe0bf2545a.jpeg";